import styled from "styled-components";
import { Theme } from "@pga/pga-component-library";

const StepBar = styled.ul`
  display: flex;
  padding: 20px 0 20px 0;

  li {
    list-style-type: none;
    display: flex;
    flex: 1;
    text-align: center;
    position: relative;
    counter-increment: step;
    z-index: 1;
  }

  li.active ~ div:before,
  li.active div:before {
    content: counter(step);
    color: ${Theme.colors.lightBlue};
    box-shadow: 0 0 0 1px ${Theme.colors.lightBlue};
  }

  li.active ~ li:after,
  li.active:after {
    border-color: ${Theme.colors.grey};
    z-index: -1;
  }

  li > div {
    margin: 0 auto;
  }

  li div:before {
    content: counter(step);
    display: inline-block;
    margin: 0 auto;
    width: 48px;
    height: 48px;
    line-height: 48px;
    font-size: 20px;
    border-radius: 48px;
    font-family: ${Theme.fonts.Montserrat};
    font-weight: 700;
    background: rgb(238, 240, 241);
    color: ${Theme.colors.grey};
    box-shadow: 0 0 0 1px ${Theme.colors.grey};
  }

  li:after {
    content: "";
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: ${Theme.colors.grey};
    width: 100%;
    position: absolute;
    top: 35%;
    right: -50%;
    z-index: -1;
  }

  li:last-child:after {
    content: none;
  }

  li > div > span {
    color: ${Theme.colors.grey};
    font-size: 14px;
    line-height: 18px;
    font-family: ${Theme.fonts.Montserrat};
    position: relative;
    padding-top: 5px;
    display: block;
  }

  li.active span {
    color: ${Theme.colors.lightBlue};
  }
`;
StepBar.displayName = "StepBar";

export default StepBar;
